import { render, staticRenderFns } from "./DatasetFilter.vue?vue&type=template&id=2c4fb3ed&"
import script from "./DatasetFilter.vue?vue&type=script&lang=js&"
export * from "./DatasetFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports